<template>
  <div class="promotions">
    <h2 class="title">
      Уведомления
    </h2>
    <div
      v-if="isSubscribed"
      class="promotions-items"
    >
      <div
        v-if="COUPONS.length"
        class="promotions-items-wrapper"
      >
        <promotion-item
          v-for="coupon in COUPONS"
          :key="coupon.id"
          :info="coupon"
        />
      </div>

      <page-info
        v-else
        class="page-info"
        title="Список уведомлений пуст"
        subtitle="Все новые персональные предложения, уведомления об акциях и скидках будут отображаться здесь"
      />
    </div>
    <page-info
      v-else
      title="Вы не получаете уведомления об акциях, новиках и скидках"
      subtitle="Чтобы получать уведомления необходимо подписаться на рассылку"
    >
      <ui-button
        text="Подписаться"
        @click="navigate('/account/subscribes')"
      />
    </page-info>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
/* Components */
import PageInfo from '../../components/common/page-info';
import PromotionItem from '../../components/account/promotion-item';

export default {
  name: 'Promotions',

  components: {
    PageInfo,
    PromotionItem
  },

  data() {
    return {
      promotions: []
    }
  },

  computed: {
    ...mapGetters({
      ACCOUNT: 'user/account',
      COUPONS: 'user/coupons',
    }),

    isSubscribed() { // проверка подписки на акции
      return (this.ACCOUNT.subscriptions || []).some(sub => sub.code === 'EMAIL' && sub.active);
    }
  },

  methods: {
    navigate(link) {
      window.location = link;
    }
  },
};
</script>

<style lang="scss">
.promotions {

  & > .title {
    margin-top: 32px;
  }

  .page-info {
    max-width: 288px;
  }
}

@include breakpoint("desktop") {
  .promotions {
    & > .title {
      margin-top: 0;
    }

    .page-info {
      max-width: 436px;
    }
  }
}
</style>